module.exports = __webpack_public_path__ + "static/media/powerdBy.7dcfa894.png";